import i18next from 'i18next';
import type {
  MemberStatus,
  Permission,
  TenantMemberSimple,
  TenantMemberStatus,
} from '@repositories/userRepository/user.types';

export class TenantMemberSimpleModel {
  private readonly _dto?: TenantMemberSimple;
  private readonly _createdDate: string;
  private readonly _updatedDate: string;
  private readonly _deleted: boolean;
  private readonly _deletedDate: string;
  private readonly _email: string;
  private readonly _id: string;
  private readonly _lastLoginedAt: string;
  private readonly _memberRole: Permission;
  private readonly _name: string;
  private readonly _phone: string;
  private readonly _status: MemberStatus;
  private readonly _tenantMemberStatus: TenantMemberStatus;
  private readonly _userGroups: string[];
  private readonly _username: string;
  private readonly _subscriptionCount: number;
  private readonly _smpSubscription: boolean;
  private readonly _mfaEnabled: boolean;

  constructor(dto?: TenantMemberSimple) {
    this._dto = dto;
    this._createdDate = dto?.createdDate || '';
    this._updatedDate = dto?.updatedDate || '';
    this._deleted = dto?.deleted || false;
    this._deletedDate = dto?.deletedDate || '';
    this._email = dto?.email || '-';
    this._id = dto?.id || '-';
    this._lastLoginedAt = dto?.lastLoginedAt || '-';
    this._memberRole = dto?.memberRole || 'USER';
    this._name = dto?.name || '-';
    this._phone = dto?.phone || '-';
    this._username = dto?.username || '-';
    this._userGroups = dto?.userGroups?.split(',') || [];
    this._status = dto?.status || 'CREATED';
    this._tenantMemberStatus = dto?.tenantMemberStatus || 'BLOCKED';
    this._subscriptionCount = dto?.subscriptionCount || 0;
    this._smpSubscription = dto?.smpSubscription || false;
    this._mfaEnabled = dto?.mfaEnabled || false;
  }

  get deleted() {
    return this._deleted;
  }

  get deletedDate() {
    return this._deletedDate;
  }

  get createdDate() {
    return this._createdDate;
  }

  get updatedDate() {
    return this._updatedDate;
  }

  get subscriptionCount() {
    return this._subscriptionCount;
  }

  get tenantMemberStatus() {
    return this._tenantMemberStatus;
  }
  get status() {
    return this._status;
  }

  get email() {
    return this._email;
  }

  get id() {
    return this._id;
  }

  get lastLoginedAt() {
    return this._lastLoginedAt;
  }

  get memberRole() {
    return this._memberRole;
  }

  get name() {
    return this._name;
  }

  get phone() {
    return this._phone;
  }

  get username() {
    return this._username;
  }

  get usergroups() {
    return this._userGroups;
  }

  get isAccountActive() {
    return this._status === 'ACTIVE';
  }

  get isAccountInactive() {
    return this._status === 'CREATED';
  }

  get isActive() {
    return this._tenantMemberStatus === 'ACTIVE';
  }

  get isStop() {
    return this._tenantMemberStatus === 'BLOCKED';
  }

  get isWait() {
    return this._tenantMemberStatus === 'ACTIVE' && this.isAccountInactive;
  }

  get isManager() {
    return (
      this._memberRole === 'GENERAL_ADMIN' ||
      this._memberRole === 'SUPER_ADMIN' ||
      this._memberRole === 'EXTERNAL_ADMIN'
    );
  }

  get managerStr() {
    switch (this._memberRole) {
      case 'GENERAL_ADMIN':
        return i18next.t('Member_Manager_07');
      case 'SUPER_ADMIN':
        return i18next.t('Member_Manager_06');
      case 'EXTERNAL_ADMIN':
        return i18next.t('Member_Manager_08');
      case 'USER':
        return i18next.t('Member_Group_07');
      default:
        return '-';
    }
  }

  get customRole() {
    return this._dto?.customRole;
  }

  get smpSubscription() {
    return this._smpSubscription || false;
  }
  get mfaEnabled() {
    return this._mfaEnabled;
  }
}
